import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { DialogShow_2 } from "../../../components/DialogService/DialogService";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
//PAGE
import P404List from "./P404List";
import P404Dialog from "./P404Dialog";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { P404GetDataList, P404CreateData } from "../../../service/400/P404Service";
import ValidateService from "../../../components/ValidateService/ValidateService";
import P404Search from "./P404Search";

export default function P404() {
    const history = useHistory();
    const toast = useRef(null);
    const [dataTable, setDataTable] = useState([]);
    const [dialog, setDialog] = useState({ dialog: false, action: "" });
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");
    const [submitted, setSubmitted] = useState(false);

    // SEARCH
    const [searchWord, setSearchWord] = useState("");
    const [searchData] = useState({
        searchWord: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onP404GetDataList();
    }, [searchData]);

    const validation = (object) => {
        if (object.caseNo === "" || object.caseName === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const submitForm = (submitForm) => {
        if (validation(submitForm)) {
            // setLoading(true);

            if (dialog.action === "บันทึก") {
                submitForm = {
                    ...submitForm,
                    userId: searchData.userId,
                    actionCode: "A",
                };
            } else if (dialog.action === "แก้ไข") {
                submitForm = {
                    ...submitForm,
                    userId: searchData.userId,
                    actionCode: "U",
                };
            }

            P404CreateData(submitForm).then(
                (res) => {
                    setLoading(false);
                    setDialog(false);

                    if (res.status === 200) {
                        if(res.data[0].statusText === ''){

                            if(res.data[0].statusCode === 'C'){
                                setTextShow(`บันทึกสมบูรณ์ `);
                            }else if(res.data[0].statusCode === 'E'){
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                        }else{
                            setTextShow(`${res.data[0].statusText}`);
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }

                    onP404GetDataList();
                },
                function (err) {
                    setLoading(false);
                    setErrData(err)
                }
            );
        }
    };

    const submitFormSearch = (submitForm) => {
        setLoading(true);
        let newData = {
            userId: searchData.userId,
            searchWord: submitForm,
        };

        onP404GetDataList(newData);
    };

    const onP404GetDataList = (data) => {
        let req = data?data:searchData;
        setLoading(true);
        P404GetDataList(req).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages(toast,"error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    // const basicDialogFooter = <Button type="button" label="Dismiss" onClick={() => setShowDialog(false)} icon="pi pi-check" className="p-button-secondary" />;

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err ={errData} setErr ={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">ลักษณะงาน</h2>
                        <hr/> */}
                        <P404Search setSearchWord={setSearchWord} searchWord={searchWord} submitForm={submitFormSearch} />
                        <P404List dataTable={dataTable} setDialog={setDialog} />
                    </div>
                </div>

                {dialog.dialog === true ? (
                    <>
                        <P404Dialog dialog={dialog} setDialog={setDialog} submitForm={(e) => submitForm(e)} dataTable={dataTable} submitted={submitted} />
                    </>
                ) : (
                    ""
                )}

                <DialogShow_2
                    visible={showDialog}
                    header="แจ้งเตือน" modal onHide={() => setShowDialog(false)}
                    className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
            </div>
        </>
    );
}
